import { useEffect } from 'react'

export const useRipple = (ref, colorBG = 'rgba(255, 255, 255, 0.3)') => {
  useEffect(() => {
    const element = ref.current
    const onRipple = (event) => {
      const diameter = Math.max(element.clientWidth, element.clientHeight)
      const radius = diameter / 2
      const { left: rectLeft, top: rectTop } = element.getBoundingClientRect()
      const left = event.clientX - rectLeft - radius
      const top = event.clientY - rectTop - radius

      const style = document.createElement('style')
      const keyframes = `
        @keyframes ripple {
          from {
            transform: scale(0);
            opacity: 1;
          }
          to {
            transform: scale(3);
            opacity: 0;
          }
        }
      `
      style.innerHTML = keyframes
      const head = document.getElementsByTagName('head')[0]
      head.appendChild(style)

      const width = diameter
      const height = diameter
      const color = colorBG
      const duration = 400
      const span = document.createElement('span')
      span.classList.add('ripple')
      span.style.cssText = `
        width: ${width}px;
        height: ${height}px;
        left: ${left}px;
        top: ${top}px;
        position: absolute;
        border-radius: 50%;
        background-color: ${color};
        pointer-events: none;
        animation: ripple ${duration}ms linear;
      `
      element.appendChild(span)
      span.addEventListener('animationend', () => {
        element.removeChild(span)
        head.removeChild(style)
      })
    }
    element.addEventListener('mousedown', onRipple)
    return () => {
      element.removeEventListener('mousedown', onRipple)
    }
  }, [ref, colorBG])
}
